// angular
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@app/core/components/button/button.component';
import {
  COMPANY_EMAIL_MAILTO,
  COMPANY_WHATSAPP_LINK,
} from '@app/shared/constants/company-contact.const';

@Component({
  selector: 'pwj-auction-support-card',
  standalone: true,
  imports: [TranslateModule, ButtonComponent, RouterLink],
  templateUrl: './auction-support-card.component.html',
  styleUrl: './auction-support-card.component.scss',
})
export class AuctionSupportCardComponent {
  contactLink = COMPANY_WHATSAPP_LINK;
  emailLink = COMPANY_EMAIL_MAILTO;
}
